import {
  initializeSocket,
  connectSocket,
  disconnectSocket,
  typedOn,
  typedOff,
  type MatchFoundPayload,
} from '@fog-chess/core';

/**
 * web socket lifecycle - thin singleton wrapper around @fog-chess/core's
 * gameSocket. The auth flow calls `connectGameSocket(token)` immediately
 * after a successful login so that global listeners (matchmaking) keep
 * receiving server pushes regardless of which screen the user is on.
 *
 * Identifier for any caller that needs to attach / detach a global listener.
 */
export const GAME_SOCKET_EVENTS = {
  MATCH_FOUND: 'match:found',
  MATCH_STARTED: 'match:started',
  QUEUE_JOINED: 'queue:joined',
  QUEUE_LEFT: 'queue:left',
  ERROR_GATE_LOCKED: 'error:gate_locked',
} as const;

/**
 * Initialize + connect the singleton socket. Safe to call multiple times
 * (initializeSocket is idempotent; connectSocket resolves early if already
 * connected).
 */
export function connectGameSocket(token: string, wsUrl: string): Promise<void> {
  if (!wsUrl) {
    return Promise.reject(new Error('FOGCHESS_WS_URL is not configured'));
  }
  initializeSocket({
    url: wsUrl,
    auth: { token },
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    transports: ['websocket', 'polling'],
  });

  return connectSocket();
}

export function disconnectGameSocket(): void {
  disconnectSocket();
}

export { typedOn, typedOff, type MatchFoundPayload };
